// Pending files collected from form inputs, held in memory until payment_success.
// Populated in processToPayment() and consumed in the Razorpay/publish handlers.
window._pendingInvitationFiles = {};
window._pendingFilesStatus = {};

// Resolves a reCAPTCHA v3 token for the given action, or '' when reCAPTCHA
// isn't configured (window.RECAPTCHA_ENABLED is set inline by the page template).
function getRecaptchaToken(action) {
    if (!window.RECAPTCHA_ENABLED || typeof grecaptcha === 'undefined') return Promise.resolve('');
    return new Promise(function (resolve) {
        grecaptcha.ready(function () {
            grecaptcha.execute(window.RECAPTCHA_SITE_KEY, { action: action }).then(resolve).catch(function () { resolve(''); });
        });
    });
}

// ── GSAP lazy-loader ──────────────────────────────────────────────────────────
function _loadGSAP(cb) {
    if (window.gsap) { cb(); return; }
    var s = document.createElement('script');
    s.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
    s.onload = function () { if (window.gsap) cb(); };
    s.onerror = function () { console.warn('[pp] GSAP failed to load'); };
    document.head.appendChild(s);
}

// ── Apple-style price-drop animation ─────────────────────────────────────────
function _animatePriceDrop(oldPricePaise, sym) {
    if (!window.gsap) return;
    var oldWrap   = document.getElementById('ppOldPriceWrap');
    var newWrap   = document.getElementById('ppNewPriceWrap');
    var strikeLine = document.getElementById('ppStrikeLine');
    var oldSymEl  = document.getElementById('ppOldSym');
    var oldIntEl  = document.getElementById('ppOldInt');
    var oldDecEl  = document.getElementById('ppOldDec');
    if (!oldWrap || !newWrap || !strikeLine) return;

    var raw = (oldPricePaise / 100).toFixed(2);
    var parts = raw.split('.');
    var intPart = parts[0];
    var decPart = parts[1];
    var showDec = decPart && decPart !== '00';

    if (oldSymEl)  oldSymEl.textContent  = sym;
    if (oldIntEl)  oldIntEl.textContent  = intPart;
    if (oldDecEl)  oldDecEl.textContent  = showDec ? '.' + decPart : '';

    gsap.set(oldWrap,   { display: 'flex', opacity: 0, y: 4, x: 0, scale: 1 });
    gsap.set(strikeLine, { scaleX: 0 });
    gsap.set(newWrap,   { opacity: 0, scale: 0.76, y: 8 });

    var tl = gsap.timeline();
    tl.to(oldWrap,    { opacity: 0.45, y: 0, duration: 0.22, ease: 'power2.out' })
      .to(strikeLine, { scaleX: 1, duration: 0.22, ease: 'power1.inOut' }, '+=0.04')
      .to(oldWrap,    { x: -3,  duration: 0.055, ease: 'none' })
      .to(oldWrap,    { x:  3,  duration: 0.055, ease: 'none' })
      .to(oldWrap,    { x: -2,  duration: 0.04,  ease: 'none' })
      .to(oldWrap,    { x:  0,  duration: 0.04,  ease: 'none' })
      .to(newWrap,    { opacity: 1, scale: 1, y: 0, duration: 0.32, ease: 'back.out(1.4)' }, '-=0.05');
}

// ── Instant (no-GSAP) old price display with strikethrough ───────────────────
function _showOldPrice(oldPricePaise, sym) {
    var oldWrap    = document.getElementById('ppOldPriceWrap');
    var strikeLine = document.getElementById('ppStrikeLine');
    var oldSymEl   = document.getElementById('ppOldSym');
    var oldIntEl   = document.getElementById('ppOldInt');
    var oldDecEl   = document.getElementById('ppOldDec');
    if (!oldWrap) return;
    var raw = (oldPricePaise / 100).toFixed(2);
    var parts = raw.split('.');
    var intPart = parts[0];
    var decPart = parts[1];
    if (oldSymEl)  oldSymEl.textContent  = sym;
    if (oldIntEl)  oldIntEl.textContent  = intPart;
    if (oldDecEl)  oldDecEl.textContent  = (decPart && decPart !== '00') ? '.' + decPart : '';
    oldWrap.style.display = 'flex';
    if (strikeLine) strikeLine.style.transform = 'translateY(-50%) scaleX(1)';
}

// ── Celebration burst when credits applied ────────────────────────────────────
function _celebrateCredits() {
    var btn = document.getElementById('ppCreditsApplyBtn');
    if (!btn) return;
    var rect = btn.getBoundingClientRect();
    var cx = rect.left + rect.width / 2;
    var cy = rect.top  + rect.height / 2;
    var symbols = ['✨', '⭐', '💰', '🌟', '✨', '⭐'];
    symbols.forEach(function (sym, i) {
        var el = document.createElement('span');
        el.textContent = sym;
        el.style.cssText = 'position:fixed;left:' + cx + 'px;top:' + cy + 'px;' +
            'font-size:1.1rem;pointer-events:none;z-index:99999;' +
            'transform:translate(-50%,-50%);will-change:transform,opacity;';
        document.body.appendChild(el);
        var angle = (i / symbols.length) * Math.PI * 2 - Math.PI / 2;
        var dist  = 55 + Math.random() * 35;
        if (window.gsap) {
            gsap.to(el, {
                x: Math.cos(angle) * dist,
                y: Math.sin(angle) * dist - 20,
                opacity: 0,
                scale: 0.4,
                duration: 0.7 + Math.random() * 0.25,
                ease: 'power2.out',
                onComplete: function () { el.remove(); }
            });
        } else {
            el.remove();
        }
    });
}

// Helper function to get invitation data (no localStorage)
function getInvitationData(data_for=null) {
    // First, try to get from window.storedInvitationData
    if (data_for == null) {
        if (window.storedInvitationData && window.storedInvitationData.success && window.storedInvitationData.data) {
            return window.storedInvitationData.data;
        }
        
        // Second, try to get from formDataStorage if available
        if (window.formDataStorage && typeof window.formDataStorage.getStoredData === 'function') {
            const storedData = window.formDataStorage.getStoredData();
            if (storedData && Object.keys(storedData).length > 0) {
                return storedData;
            }
        }
    }
    
    // Fallback: collect from all form inputs with data-theme-key.
    // On update pages, seed formData with the server-saved data first so that fields
    // which haven't yet finished loading into the DOM retain their correct saved values.
    const _bodyForSeed = document.querySelector('body');
    const _isUpdateForSeed = _bodyForSeed && _bodyForSeed.getAttribute('data-cp') === 'update';
    const formData = {};
    if (_isUpdateForSeed && window.storedInvitationData && window.storedInvitationData.success && window.storedInvitationData.data) {
        const _base = window.storedInvitationData.data;
        Object.keys(_base).forEach(function(k) {
            if (k !== 'files') formData[k] = _base[k];
        });
    }
    const allInputs = document.querySelectorAll('[data-theme-key]');
    
    allInputs.forEach(input => {
        const key = input.getAttribute('data-theme-key');
        if (key) {
            // Skip file inputs — handled separately
            if (input.type === 'file') return;
            // Skip media inputs that have a pending file selected (blob URL, not real data)
            if (input._selectedFiles && input._selectedFiles.length > 0) return;
            
            let value;
            let keyParts = key.split('.');

            if (input.type === 'checkbox') {
                value = input.checked;
            } else if (input.type === 'radio') {
                if (input.checked) {
                    value = input.value;
                }
            } else if (input.tagName === 'SELECT') {
                value = input.value;
            } else {
                value = input.value;
            }
            
            if (keyParts.length > 1) {
                // Nested key (e.g., invitation.address.city)
                let currentLevel = formData;
                const isEnabled = document.querySelector(`[data-theme-key='${keyParts[0]}_enabled']`);
                if (isEnabled && isEnabled.checked) {
                    keyParts.forEach((part, index) => {
                        if (index === keyParts.length - 1) {
                            // Last part, set the value
                            currentLevel[part] = value;
                        } else {
                            // Intermediate part, ensure object exists
                            if (!currentLevel[part]) {
                                currentLevel[part] = {};
                            }
                            currentLevel = currentLevel[part];
                        }
                    });
                }
            } else {
                if (value !== undefined && value !== '') {
                    formData[key] = value;
                }
            }
        }
    });
    
    // Check if RSVP is enabled and include custom form data
    const rsvpEnabled = document.querySelector('[data-theme-key="rsvp_enabled"]');
    if (rsvpEnabled && rsvpEnabled.checked) {
        // Try to get custom RSVP questions from formDataStorage first
        let customQuestions = [];
        
        if (window.formDataStorage && typeof window.formDataStorage.getStoredData === 'function') {
            const storedData = window.formDataStorage.getStoredData();
            if (storedData.custom_rsvp_questions && Array.isArray(storedData.custom_rsvp_questions)) {
                customQuestions = storedData.custom_rsvp_questions;
            }
        }
        
        // Fallback: Get from DOM if not in storage
        if (customQuestions.length === 0) {
            const questionItems = document.querySelectorAll('.custom-question-item');
            
            questionItems.forEach((item, index) => {
                const questionId = item.dataset.questionId;
                const typeSelect = item.querySelector('.question-type-select');
                const textInput = item.querySelector('.question-text-input');
                const requiredCheck = item.querySelector('.question-required-check');
                const optionInputs = item.querySelectorAll('.option-input');
                
                const questionText = textInput?.value?.trim() || '';
                const questionType = typeSelect?.value || 'text';
                
                // Validate: Skip if question text is empty
                if (!questionText) {
                    return;
                }
                
                // For choice-type questions, validate options
                const choiceTypes = ['single', 'multiple', 'yesno'];
                let validOptions = [];
                
                if (choiceTypes.includes(questionType)) {
                    if (questionType === 'yesno') {
                        validOptions = ['Yes', 'No'];
                    } else {
                        validOptions = Array.from(optionInputs)
                            .map(input => input.value.trim())
                            .filter(val => val !== '');

                        // Skip if choice-type question has no valid options
                        if (validOptions.length === 0) {
                            return;
                        }
                    }
                }
                
                const question = {
                    id: questionId,
                    order: index + 1,
                    type: questionType,
                    question: questionText,
                    required: requiredCheck?.checked || false,
                    options: choiceTypes.includes(questionType) ? validOptions : []
                };
                
                customQuestions.push(question);
            });
        }
        
        // Add custom questions to form data if any exist and are validated
        if (customQuestions.length > 0) {
            // Additional validation: ensure all questions have text and choice-types have options
            const validatedQuestions = customQuestions.filter(q => {
                if (!q.question || q.question.trim() === '') return false;
                
                const choiceTypes = ['single', 'multiple', 'yesno'];
                if (choiceTypes.includes(q.type)) {
                    if (q.type === 'yesno') {
                        q.options = ['Yes', 'No'];
                        return true;
                    }
                    return q.options && Array.isArray(q.options) && q.options.length > 0;
                }
                
                return true;
            });
            
            if (validatedQuestions.length > 0) {
                formData.custom_rsvp_questions = validatedQuestions;
            }
        }
    }
    
    // Merge data from formDataStorage to preserve complex fields like backgroundMusic
    if (window.formDataStorage && typeof window.formDataStorage.getStoredData === 'function') {
        const storedData = window.formDataStorage.getStoredData();
        
        // Preserve custom_rsvp_questions if it exists in storage and not already in formData
        if (!formData.custom_rsvp_questions && storedData.custom_rsvp_questions) {
            formData.custom_rsvp_questions = storedData.custom_rsvp_questions;
        }

        // Preserve gift_registry_items if they exist in storage
        if (!formData.gift_registry_items && storedData.gift_registry_items) {
            formData.gift_registry_items = storedData.gift_registry_items;
        }

        // Always prefer schedule_items from formDataStorage (has latest in-memory edits)
        if (storedData.schedule_items) {
            formData.schedule_items = storedData.schedule_items;
        }
    }
    return formData;
}

function getInvitationFiles() {
    const files = {};
    const filesStatus = {};

    // Scan ALL inputs with data-theme-uid — covers both native file inputs
    // and text inputs used by the media picker (which stores the File object
    // in inputEl._selectedFiles via applyFileToInput).
    const allInputs = document.querySelectorAll('[data-theme-uid]');
    allInputs.forEach(input => {
        const key = input.dataset.themeUid;
        if (!key) return;

        const fileInputAction = input.getAttribute('data-file-action') || 'upload';

        // Media-picker files stored by applyFileToInput
        if (input._selectedFiles && input._selectedFiles.length > 0) {
            filesStatus[key] = fileInputAction;
            files[key] = input.getAttribute('data-file-multiple') === 'true'
                ? Array.from(input._selectedFiles)
                : input._selectedFiles[0];
            return;
        }

        // Native file inputs
        if (input.type === 'file' && input.files && input.files.length > 0) {
            filesStatus[key] = fileInputAction;
            files[key] = input.multiple
                ? Array.from(input.files)
                : input.files[0];
            return;
        }

        // Existing server files explicitly marked for deletion (no new file selected)
        if (fileInputAction === 'delete') {
            filesStatus[key] = 'delete';
        }
    });

    return { files, filesStatus };
}

// Payment functionality
window.setupPaymentHandlers = function setupPaymentHandlers() {
    // Toggle payment options
    const enablePaymentsSwitch = document.getElementById("enablePayments");
    const paymentOptions = document.getElementById("paymentOptions");

    if (enablePaymentsSwitch && paymentOptions) {
        enablePaymentsSwitch.addEventListener("change", function () {
            paymentOptions.style.display = this.checked ? "block" : "none";
        });
    }

    // Add payment item
    const addPaymentItemBtn = document.getElementById("addPaymentItemBtn");
    const paymentItemsContainer = document.querySelector(
        ".payment-items-container"
    );

    if (addPaymentItemBtn && paymentItemsContainer) {
        addPaymentItemBtn.addEventListener("click", function () {
            const paymentItems =
                paymentItemsContainer.querySelectorAll(".payment-item");
            const newIndex = paymentItems.length + 1;

            const newItem = document.createElement("div");
            newItem.className = "payment-item card p-3 mb-3";
            newItem.innerHTML = `
                    <div class="d-flex justify-content-end mb-2">
                        <button type="button" class="btn btn-sm btn-outline-danger remove-payment-item">
                            <i class="bi bi-trash"></i>
                        </button>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group mb-3">
                                <label for="itemName${newIndex}" class="form-label">Item Name</label>
                                <input type="text" class="form-control shadow-none border border-secondary" id="itemName${newIndex}" required>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group mb-3">
                                <label for="itemPrice${newIndex}" class="form-label">Price</label>
                                <div class="input-group">
                                    <span class="input-group-text">$</span>
                                    <input type="number" class="form-control shadow-none border border-secondary" id="itemPrice${newIndex}" min="0" step="0.01" required>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group mb-3">
                                <label for="itemQuantity${newIndex}" class="form-label">Quantity</label>
                                <input type="number" class="form-control shadow-none border border-secondary" id="itemQuantity${newIndex}" min="1" value="1">
                            </div>
                        </div>
                    </div>
                    <div class="form-group mb-3">
                        <label for="itemDescription${newIndex}" class="form-label">Description</label>
                        <textarea class="form-control shadow-none border border-secondary" id="itemDescription${newIndex}" rows="2"></textarea>
                    </div>
                `;

            paymentItemsContainer.appendChild(newItem);

            // Add event listener to remove button
            const removeBtn = newItem.querySelector(".remove-payment-item");
            if (removeBtn) {
                removeBtn.addEventListener("click", function () {
                    paymentItemsContainer.removeChild(newItem);
                });
            }
        });
    }

    // RSVP toggle functionality
    const toggleCheckboxes = document.querySelectorAll(
        "input[data-show-classlist]"
    );
    toggleCheckboxes.forEach((checkbox) => {
        checkbox.addEventListener("change", function () {
            const targetClass = this.getAttribute("data-show-classlist");
            const hideClass = this.getAttribute("data-hide-classlist");

            if (targetClass) {
                const targetElements = document.querySelectorAll(
                    "." + targetClass
                );
                targetElements.forEach((el) => {
                    el.style.display = this.checked ? "block" : "none";
                });
            }

            if (hideClass) {
                const hideElements = document.querySelectorAll("." + hideClass);
                hideElements.forEach((el) => {
                    el.style.display = this.checked ? "none" : "block";
                });
            }
        });

        // Initialize display state
        const targetClass = checkbox.getAttribute("data-show-classlist");
        if (targetClass) {
            const targetElements = document.querySelectorAll("." + targetClass);
            targetElements.forEach((el) => {
                el.style.display = checkbox.checked ? "block" : "none";
            });
        }
    });

    // Add remove button to first payment item
    const firstPaymentItem = document.querySelector(".payment-item");
    if (
        firstPaymentItem &&
        !firstPaymentItem.querySelector(".remove-payment-item")
    ) {
        const removeButtonContainer = document.createElement("div");
        removeButtonContainer.className = "d-flex justify-content-end mb-2";
        removeButtonContainer.innerHTML = `
                <button type="button" class="btn btn-sm btn-outline-danger remove-payment-item">
                    <i class="bi bi-trash"></i>
                </button>
            `;
        firstPaymentItem.insertBefore(
            removeButtonContainer,
            firstPaymentItem.firstChild
        );

        const removeBtn = firstPaymentItem.querySelector(
            ".remove-payment-item"
        );
        removeBtn.addEventListener("click", function () {
            // Don't remove if it's the only item
            const paymentItems = document.querySelectorAll(".payment-item");
            if (paymentItems.length > 1) {
                paymentItemsContainer.removeChild(firstPaymentItem);
            }
        });
    }
}

// Flag to prevent duplicate payment processing
let isProcessingPayment = false;

// billingForm submit event listener
window.processToPayment = async function processToPayment() {
    // ── Required-field gate: block payment if any required PPM field is empty ─
    if (typeof window.validatePaymentFields === 'function' && !window.validatePaymentFields()) {
        return;
    }

    // ── Auth gate: show PPM login overlay if the user is not signed in ───────
    if (!window.userIsAuthenticated) {
        if (typeof window.requireAuth === 'function') {
            window.requireAuth(function () {
                // Re-validate required fields after login before proceeding
                if (typeof window.validatePaymentFields === 'function' && !window.validatePaymentFields()) return;
                window.processToPayment();
            });
        } else {
            window.location.href = '/auth/login/?next=' + encodeURIComponent(window.location.pathname + window.location.search);
        }
        return;
    }

    // Prevent duplicate calls
    if (isProcessingPayment) {
        // console.log('Payment already being processed, skipping duplicate call');
        return;
    }
    
    try {
        isProcessingPayment = true;
        
        // Ensure RSVP data is saved if RSVP is enabled
        const rsvpEnabled = document.getElementById('enableRSVP');
        if (rsvpEnabled && rsvpEnabled.checked && typeof window.saveRSVPFormData === 'function') {
            // console.log('Saving RSVP data before payment generation...');
            window.saveRSVPFormData();
        }

        // Ensure schedule data is saved if event schedule is enabled
        // (captures in-progress field edits that haven't fired onchange yet)
        const scheduleEnabled = document.getElementById('eventScheduleEnabled');
        if (scheduleEnabled && scheduleEnabled.checked && typeof window.saveScheduleData === 'function') {
            window.saveScheduleData();
        }

        // Ensure gift registry data is saved if gift registry is enabled
        const giftRegistryEnabled = document.getElementById('giftRegistryEnabled');
        if (giftRegistryEnabled && giftRegistryEnabled.checked && typeof window.saveGiftRegistryData === 'function') {
            window.saveGiftRegistryData();
        }
        
        const invitationDataObj = getInvitationData('for_payment');
        // console.log(invitationDataObj);
        
        const invitationData = JSON.stringify(invitationDataObj);
        // Get body data-template-id="{{ theme.template_id }}"
        // console.log("Payment Invitation Data: ", invitationDataObj);
        // console.log("Payment Invitation Data (stringified): ", invitationData);
        const body = document.querySelector('body');
        
        const templateID = body.getAttribute('data-template-id');
        
        // check if the current url has create or update in it
        const action =  body.getAttribute('data-cp');
        const isUpdate = action === 'update' ? true : false;
        const isCreate = action === 'create' ? true : false;

        let invitationUID = null;
        if (isUpdate) {
            invitationUID = body.getAttribute('data-invitation-uid');
        }

        if (!invitationData) {
            console.error("No invitation data found.");
            showPaymentError("No invitation data found. Please complete the form first.");
            return;
        }

        let parsedInvitationData;
        try {
            parsedInvitationData = JSON.parse(invitationData);
        } catch (e) {
            console.error("Error parsing invitation data:", e);
            showPaymentError("Invalid invitation data. Please try again.");
            return;
        }
        // console.log('Parsed Invitation Data:', parsedInvitationData);

        // Fix: Add proper null checking for template data
        // if (!parsedInvitationData || !parsedInvitationData.template || !parsedInvitationData.template.id) {
        //     console.error("Invalid invitation data structure - template information missing");
        //     return;
        // }

        // if (templateID != parsedInvitationData.template.id) {
        //     alert("Please select a valid template.");
        //     return;
        // }
        
        // Store pending files in memory — they will be sent to payment_success, NOT to generate_payment
        const filesToUpload = getInvitationFiles();
        window._pendingInvitationFiles = filesToUpload.files || {};
        window._pendingFilesStatus = filesToUpload.filesStatus || {};

        const recaptchaToken = await getRecaptchaToken('create_invite');

        // Always send JSON to generate_payment (price calculation only, no file uploads)
        let fetchOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: {
                "X-CSRFToken": (typeof getCookie === 'function' ? getCookie("csrftoken") : window.getCookie("csrftoken")),
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                invitationData: parsedInvitationData,
                page: action,
                templateID: templateID,
                invitationUID: invitationUID,
                filesStatus: window._pendingFilesStatus,
                couponCode: window._appliedCoupon || '',
                useCredits: window._usePartnerCredits || false,
                recaptchaToken: recaptchaToken,
            }),
        };

        // console.log('📤 Sending payment request:', fetchOptions);
        
        const response = await fetch("/payment/generate-payment/", fetchOptions);

        if (!response.ok) {
            const errorData = await response.json().catch(() => null);
            const errorMessage = errorData?.error || `Server error (${response.status}). Please try again.`;
            showPaymentError(errorMessage);
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        
        // Check if there's an error in the response data
        if (data.error) {
            showPaymentError(data.error);
            return;
        }
        
        const html = data.html;

        // ── Inject checkout summary into sidebar container if it's present ─────
        const paymentContainerEl = document.getElementById('paymentContainer');
        if (paymentContainerEl) {
            paymentContainerEl.innerHTML = html;
            animatePaymentContent();
        }

        // ── Update payment-popup amount display ───────────────────────────────
        const popupOverlay = document.getElementById('paymentPopupOverlay');
        if (popupOverlay) {
            const sym = data.currency_symbol || '₹';
            const amountValueEl  = document.getElementById('paymentPopupAmountValue');
            const amountPeriodEl = document.getElementById('paymentPopupAmountPeriod');
            const newPriceWrapEl = document.getElementById('ppNewPriceWrap');
            const oldPriceWrapEl = document.getElementById('ppOldPriceWrap');

            if (amountValueEl) {
                const amountPaise = data.amount || 0;
                const hasDiscount = window._usePartnerCredits || window._appliedCoupon;

                // Latch original undiscounted price on first load when no discount is active
                if (!window._ppOriginalPricePaise && amountPaise > 0 && !hasDiscount) {
                    window._ppOriginalPricePaise = amountPaise;
                }
                const origPricePaise = window._ppOriginalPricePaise || amountPaise;
                const priceDropped = hasDiscount && amountPaise > 0 && amountPaise < origPricePaise;
                const doAnimate = window._ppAnimatePrice && priceDropped;
                window._ppAnimatePrice = false;

                amountValueEl.dataset.rawAmount = amountPaise;

                const newPriceHTML = (s, intPart, decPart, showDec) =>
                    `<span class="pp-sym">${s}</span>` +
                    `<span class="pp-int">${intPart}</span>` +
                    (showDec ? `<span class="pp-dec">.${decPart}</span>` : '');

                if (newPriceWrapEl) {
                    if (data.is_payment_required && amountPaise > 0) {
                        const raw = (amountPaise / 100).toFixed(2);
                        const [intPart, decPart] = raw.split('.');
                        newPriceWrapEl.innerHTML = newPriceHTML(sym, intPart, decPart, decPart !== '00');
                    } else {
                        if (oldPriceWrapEl) oldPriceWrapEl.style.display = 'none';
                        newPriceWrapEl.innerHTML = '<span class="pp-int">Free</span>';
                    }

                    // Always show old price with strikethrough when any discount is active
                    if (priceDropped) {
                        _showOldPrice(origPricePaise, sym);
                        if (doAnimate) {
                            _loadGSAP(function () { _animatePriceDrop(origPricePaise, sym); });
                        }
                    } else {
                        if (oldPriceWrapEl) oldPriceWrapEl.style.display = 'none';
                    }
                }
            }
            if (amountPeriodEl) {
                amountPeriodEl.textContent = data.is_payment_required
                    ? 'One-time payment · Invite published instantly'
                    : 'No payment required · Invite published instantly';
            }
        }

        // ── Partner credits section ──────────────────────────────────────────
        const creditsSection = document.getElementById('ppCreditsSection');
        const creditsLabel   = document.getElementById('ppCreditsLabel');
        const creditsApplyBtn = document.getElementById('ppCreditsApplyBtn');
        const creditsAvail = data.partner_credits_available || 0;
        const creditsSym = data.currency_symbol || '₹';

        if (creditsSection) {
            // Show credits card if user has credits, OR if credits are already applied
            // (even when price became free — user must still be able to remove them)
            const showCredits = creditsAvail > 0 && (data.is_payment_required || window._usePartnerCredits);
            if (showCredits) {
                creditsSection.style.display = '';

                if (creditsLabel) {
                    const rate = data.currency_rate || 1;
                    const themePriceInr = data.theme_price_inr || creditsAvail;
                    const creditsAvailPaise = creditsAvail * 100;
                    const maxUsableInr = Math.min(creditsAvailPaise, themePriceInr);
                    const localAmt = (maxUsableInr * rate).toFixed(2).replace(/\.00$/, '');

                    if (window._usePartnerCredits && data.credit_discount_paise > 0) {
                        const appliedAmt = (data.credit_discount_paise / 100).toFixed(2).replace(/\.00$/, '');
                        creditsLabel.textContent = `${creditsAvail} credits — ${creditsSym}${appliedAmt} off`;
                    } else if (window._usePartnerCredits) {
                        creditsLabel.textContent = `${creditsAvail} credits — covers full price`;
                    } else {
                        creditsLabel.textContent = `${creditsAvail} credits — ${creditsSym}${localAmt} off`;
                    }
                }

                if (creditsSection) {
                    creditsSection.classList.toggle('is-applied', !!window._usePartnerCredits);
                }
                if (creditsApplyBtn) {
                    if (window._usePartnerCredits) {
                        creditsApplyBtn.textContent = 'Remove';
                        creditsApplyBtn.disabled = false;
                        creditsApplyBtn.className = 'pp-credits-action-btn pp-credits-remove';
                    } else {
                        creditsApplyBtn.textContent = 'Use';
                        creditsApplyBtn.disabled = false;
                        creditsApplyBtn.className = 'pp-credits-action-btn';
                    }
                }
            } else {
                creditsSection.style.display = 'none';
            }
        }

        if (creditsApplyBtn && !creditsApplyBtn._ppmBound) {
            creditsApplyBtn._ppmBound = true;
            creditsApplyBtn.addEventListener('click', function () {
                window._usePartnerCredits = !window._usePartnerCredits;
                window._ppAnimatePrice = true;
                if (window._usePartnerCredits) window._ppCelebratePending = true;

                creditsApplyBtn.disabled = true;
                creditsApplyBtn.innerHTML = '<span class="pp-btn-arc" style="width:14px;height:14px;border-width:2px;" aria-hidden="true"></span>';
                creditsApplyBtn.className = 'pp-credits-action-btn';
                if (creditsLabel) creditsLabel.textContent = '';

                const payBtn2 = document.getElementById('paymentPopupPayBtn');
                if (payBtn2) { payBtn2.disabled = true; payBtn2.innerHTML = '<span class="pp-btn-arc" aria-hidden="true"></span>'; }
                const npw2 = document.getElementById('ppNewPriceWrap');
                if (npw2) npw2.innerHTML = '<span class="pp-amount-skeleton"></span>';
                else {
                    const amtEl2 = document.getElementById('paymentPopupAmountValue');
                    if (amtEl2) amtEl2.innerHTML = '<span class="pp-amount-skeleton"></span>';
                }
                window.processToPayment();
            });
        }

        // ── Wire up currency selector ────────────────────────────────────────
        const currencySelect = document.getElementById('paymentPopupCurrencySelect');
        if (currencySelect && !currencySelect._ppmBound) {
            currencySelect._ppmBound = true;
            currencySelect.addEventListener('change', function () {
                const chosen = this.value;
                document.cookie = `currency=${chosen}; path=/; max-age=${30 * 24 * 3600}; SameSite=Lax`;
                const payBtn = document.getElementById('paymentPopupPayBtn');
                if (payBtn) {
                    payBtn.disabled = true;
                    payBtn.innerHTML = '<span class="pp-btn-arc" aria-hidden="true"></span>';
                }
                const npwCurr = document.getElementById('ppNewPriceWrap');
                if (npwCurr) npwCurr.innerHTML = '<span class="pp-amount-skeleton"></span>';
                else { const amtEl = document.getElementById('paymentPopupAmountValue'); if (amtEl) amtEl.innerHTML = '<span class="pp-amount-skeleton"></span>'; }
                const opwCurr = document.getElementById('ppOldPriceWrap');
                if (opwCurr) opwCurr.style.display = 'none';
                const periodEl = document.getElementById('paymentPopupAmountPeriod');
                if (periodEl) periodEl.innerHTML = '<span class="pp-period-skeleton"></span>';
                // Reset original price baseline when currency changes so it re-latches in the new currency
                window._ppOriginalPricePaise = null;
                // Reset coupon when currency changes; keep credits applied if already used
                window._appliedCoupon = null;
                const fb = document.getElementById('ppCouponFeedback');
                if (fb) fb.innerHTML = '';
                const ci = document.getElementById('ppCouponInput');
                if (ci) { ci.value = ''; ci.disabled = false; }
                const cab = document.getElementById('ppCouponApplyBtn');
                if (cab) { cab.innerHTML = 'Apply'; cab.disabled = false; cab._ppmBound = false; }
                const appliedChip = document.getElementById('ppCouponApplied');
                const inputRow2   = document.getElementById('ppCouponInputRow');
                if (appliedChip) appliedChip.classList.remove('is-visible');
                if (inputRow2)   inputRow2.style.display = '';
                // Credits stay applied across currency changes
                const credLbl = document.getElementById('ppCreditsLabel');
                if (credLbl) credLbl.textContent = '';
                isProcessingPayment = false;
                window.processToPayment();
            });
        }

        // ── Wire up coupon Apply button ───────────────────────────────────────
        const couponApplyBtn = document.getElementById('ppCouponApplyBtn');
        if (couponApplyBtn && !couponApplyBtn._ppmBound) {
            couponApplyBtn._ppmBound = true;
            couponApplyBtn.addEventListener('click', async function () {
                const input = document.getElementById('ppCouponInput');
                const feedback = document.getElementById('ppCouponFeedback');
                const code = (input ? input.value : '').trim().toUpperCase();
                if (!code) { if (feedback) feedback.innerHTML = '<span class="pp-coupon-err">Enter a coupon code</span>'; return; }

                couponApplyBtn.disabled = true;
                couponApplyBtn.innerHTML = '<span class="pp-btn-arc" style="width:14px;height:14px;border-width:2px;" aria-hidden="true"></span>';

                const amtEl = document.getElementById('paymentPopupAmountValue');
                const rawAmount = amtEl ? (amtEl.dataset.rawAmount || 0) : 0;

                try {
                    const res = await fetch('/payment/validate-coupon/', {
                        method: 'POST',
                        credentials: 'same-origin',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-CSRFToken': (typeof getCookie === 'function' ? getCookie('csrftoken') : window.getCookie('csrftoken')),
                        },
                        body: JSON.stringify({ code, amount: rawAmount }),
                    });
                    const result = await res.json();
                    
                    if (result.valid) {
                        window._appliedCoupon = result.coupon_code;
                        // Show applied chip, hide input row
                        const inputRow   = document.getElementById('ppCouponInputRow');
                        const appliedDiv = document.getElementById('ppCouponApplied');
                        const codeEl     = document.getElementById('ppAppliedCode');
                        const savingsEl  = document.getElementById('ppAppliedSavings');
                        if (inputRow)   inputRow.style.display = 'none';
                        if (codeEl)     codeEl.textContent = result.coupon_code;
                        if (savingsEl)  savingsEl.textContent = result.message;
                        if (appliedDiv) appliedDiv.classList.add('is-visible');
                        if (feedback)   feedback.innerHTML = '';
                        // Re-fetch payment with coupon applied
                        window._ppAnimatePrice = true;
                        const payBtn = document.getElementById('paymentPopupPayBtn');
                        if (payBtn) { payBtn.disabled = true; payBtn.innerHTML = '<span class="pp-btn-arc" aria-hidden="true"></span>'; }
                        const npwCoup = document.getElementById('ppNewPriceWrap');
                        if (npwCoup) npwCoup.innerHTML = '<span class="pp-amount-skeleton"></span>';
                        else if (amtEl) amtEl.innerHTML = '<span class="pp-amount-skeleton"></span>';
                        const periodEl = document.getElementById('paymentPopupAmountPeriod');
                        if (periodEl) periodEl.innerHTML = '<span class="pp-period-skeleton"></span>';
                        isProcessingPayment = false;
                        window.processToPayment();
                    } else {
                        window._appliedCoupon = null;
                        if (feedback) feedback.innerHTML = `<div class="pp-err-box"><i class="bi bi-exclamation-circle-fill"></i><span>${result.message}</span></div>`;
                        if (input) { input.classList.add('pp-input-shake'); setTimeout(function () { input.classList.remove('pp-input-shake'); }, 500); }
                        couponApplyBtn.innerHTML = 'Apply';
                        couponApplyBtn.disabled = false;
                    }
                } catch (e) {
                    if (feedback) feedback.innerHTML = '<div class="pp-err-box"><i class="bi bi-exclamation-circle-fill"></i><span>Could not validate coupon. Try again.</span></div>';
                    couponApplyBtn.innerHTML = 'Apply';
                    couponApplyBtn.disabled = false;
                }
            });
        }

        // ── Wire up coupon Remove button ──────────────────────────────────────
        const couponRemoveBtn = document.getElementById('ppCouponRemoveBtn');
        if (couponRemoveBtn && !couponRemoveBtn._ppmBound) {
            couponRemoveBtn._ppmBound = true;
            couponRemoveBtn.addEventListener('click', function () {
                window._appliedCoupon = null;
                const input      = document.getElementById('ppCouponInput');
                const feedback   = document.getElementById('ppCouponFeedback');
                const applyBtn   = document.getElementById('ppCouponApplyBtn');
                const appliedDiv = document.getElementById('ppCouponApplied');
                const inputRow   = document.getElementById('ppCouponInputRow');
                // Hide chip, reveal input row
                if (appliedDiv) appliedDiv.classList.remove('is-visible');
                if (inputRow)   inputRow.style.display = '';
                if (input) { input.value = ''; input.disabled = false; setTimeout(function () { input.focus(); }, 50); }
                if (feedback) feedback.innerHTML = '';
                if (applyBtn) { applyBtn.innerHTML = 'Apply'; applyBtn.disabled = false; applyBtn._ppmBound = false; }
                // Re-fetch price without coupon
                window._ppAnimatePrice = true;
                const payBtn = document.getElementById('paymentPopupPayBtn');
                if (payBtn) { payBtn.disabled = true; payBtn.innerHTML = '<span class="pp-btn-arc" aria-hidden="true"></span>'; }
                const npwWrap = document.getElementById('ppNewPriceWrap');
                if (npwWrap) npwWrap.innerHTML = '<span class="pp-amount-skeleton"></span>';
                const periodEl = document.getElementById('paymentPopupAmountPeriod');
                if (periodEl) periodEl.innerHTML = '<span class="pp-period-skeleton"></span>';
                isProcessingPayment = false;
                window.processToPayment().catch(function (err) {
                    console.warn('[coupon-remove] processToPayment error:', err);
                    isProcessingPayment = false;
                });
            });
        }

        // paymentPublishBtnBox is injected as part of the sidebar checkout HTML;
        // in popup-only mode it won't exist — fall back to the popup pay button.
        let payPulishBtnBox = document.querySelector('#paymentPublishBtnBox');
        const popupPayBtn = document.getElementById('paymentPopupPayBtn');

        // Create/Update page: always free — auto-submit without showing any popup or sidebar.
        // Creation is free; payment happens at the unlock/share step after creation.
        if (!data.is_payment_required) {
            await _submitFreePublish(data, action, body, isUpdate);
            return;
        }

        if (data.is_payment_required) {
            let btnText = `Pay ${data.currency_symbol}${(data.amount / 100).toFixed(2)} <i class='bi bi-credit-card-fill ms-1'></i>`;
            btnText = data.amount > 0 ? btnText : isCreate ? 'Free Trial' : isUpdate ? 'Update' : 'Free Trial';

            if (payPulishBtnBox) {
                // ── Sidebar flow ───────────────────────────────────────────────
                payPulishBtnBox.innerHTML = `
                    <div class="w-100">
                        <button type="button" class="btn-action-next" id="razorpayBtn">
                            <span class="btn-text">${btnText}</span>
                            <span class="btn-loader d-none">
                                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Processing...
                            </span>
                        </button>
                    </div>
                `;
                document.getElementById('razorpayBtn').onclick = async function (e) {
                    e.preventDefault();
                    const btn = this;
                    btn.querySelector('.btn-text').classList.add('d-none');
                    btn.querySelector('.btn-loader').classList.remove('d-none');
                    btn.disabled = true;
                    initializePayment(
                        data.amount, data.order_id, data.razorpay_key_id,
                        data.currency, data.description, action,
                        data.hash_invoice_data, data.hash_invitation_data
                    );
                };
            } else if (popupPayBtn) {
                // ── Popup flow (Razorpay) ──────────────────────────────────────
                popupPayBtn.disabled = false;
                const _payLabel = `<i class="bi bi-credit-card-fill me-2"></i>Pay & Publish`;
                popupPayBtn.innerHTML = _payLabel;
                popupPayBtn.dataset.readyLabel = _payLabel;
                popupPayBtn.onclick = async function (e) {
                    e.preventDefault();
                    popupPayBtn.disabled = true;
                    popupPayBtn.innerHTML = '<span class="pp-btn-arc" aria-hidden="true"></span><span style="margin-left:8px">Processing…</span>';
                    initializePayment(
                        data.amount, data.order_id, data.razorpay_key_id,
                        data.currency, data.description, action,
                        data.hash_invoice_data, data.hash_invitation_data
                    );
                };
            }
        } else {
            // Free / no-payment path
            let btnText = data.amount > 0
                ? `Pay ${data.currency_symbol}${(data.amount / 100).toFixed(2)} <i class='bi bi-credit-card-fill ms-1'></i>`
                : isCreate ? 'Free Trial' : isUpdate ? 'Update' : 'Free Trial';

            if (payPulishBtnBox) {
                // ── Sidebar flow (free publish) ────────────────────────────────
                payPulishBtnBox.innerHTML = `
                    <button type="button" class="btn-action-next" id="publishBtn">
                        <span class="btn-text">${btnText}</span>
                        <span class="btn-loader d-none">
                            <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Processing...
                        </span>
                    </button>
                `;
                document.getElementById('publishBtn').addEventListener('click', async function () {
                    const btn = this;
                    btn.querySelector('.btn-text').classList.add('d-none');
                    btn.querySelector('.btn-loader').classList.remove('d-none');
                    btn.disabled = true;
                    await _submitFreePublish(data, action, body, isUpdate);
                });
            } else if (popupPayBtn) {
                // ── Popup flow (free publish) ──────────────────────────────────
                popupPayBtn.disabled = false;
                popupPayBtn.innerHTML = `<i class="bi bi-send-fill me-2"></i>${isCreate ? 'Publish Invite' : isUpdate ? 'Update Invite' : 'Publish Invite'}`;
                popupPayBtn.onclick = async function (e) {
                    e.preventDefault();
                    popupPayBtn.disabled = true;
                    popupPayBtn.innerHTML = '<span class="pp-btn-arc" aria-hidden="true"></span><span style="margin-left:8px">Publishing…</span>';
                    await _submitFreePublish(data, action, body, isUpdate);
                };
            }
        }

        // Remove the value of the input file fields to prevent accidental resubmission of files if user goes back to edit form
        const inputFields = document.querySelectorAll('input[type="file" ][data-theme-key]');
        inputFields.forEach(input => input.value = '');
    } catch (error) {
        console.error("Error processing payment:", error);
        showPaymentError("An unexpected error occurred. Please try again.");
    } finally {
        // Reset flag after processing completes (or fails)
        isProcessingPayment = false;
    }
}

// Shared helper: submit a free (no-payment) publish to /payment/payment-success/
async function _submitFreePublish(data, action, body, isUpdate) {
    const template_id = body.getAttribute('data-template-id');
    const csrftoken = (typeof getCookie === 'function' ? getCookie('csrftoken') : window.getCookie('csrftoken'));
    const formData = new FormData();
    formData.append('csrfmiddlewaretoken', csrftoken);
    formData.append('amount', data.amount);
    formData.append('publish_data', data.hash_invitation_data || '');
    formData.append('templateID', template_id);
    formData.append('action', action);
    formData.append('_hash_invoice_data', data.hash_invoice_data || '');
    formData.append('_hash_invitation_data', data.hash_invitation_data || '');
    if (isUpdate) {
        formData.append('invitationUID', document.querySelector('body').getAttribute('data-invitation-uid'));
    }
    Object.entries(window._pendingInvitationFiles || {}).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            value.forEach(f => formData.append(`files[${key}][]`, f));
        } else {
            formData.append(`files[${key}]`, value);
        }
    });
    if (Object.keys(window._pendingFilesStatus || {}).length > 0) {
        formData.append('filesStatus', JSON.stringify(window._pendingFilesStatus));
    }
    try {
        const res = await fetch('/payment/payment-success/', {
            method: 'POST',
            credentials: 'same-origin',
            body: formData,
        });
        const contentType = res.headers.get('content-type') || '';
        if (contentType.includes('application/json')) {
            const json = await res.json();
            if (json.redirect) { window.location.href = json.redirect; return; }
        }
        const html = await res.text();
        document.open('text/html', 'replace');
        document.write(html);
        document.close();
    } catch (err) {
        console.error('Publish request failed:', err);
        window.location.href = '/payment/payment-success/';
    }
}

// Helper function to display payment errors
function showPaymentError(message) {
    const paymentContainer = document.getElementById('paymentContainer');
    if (paymentContainer) {
        paymentContainer.innerHTML = `
            <div class="d-flex flex-column align-items-center justify-content-center h-100 p-4" role="alert">
                <h2 class="poppins text-muted fs-1 mb-5">(｡•́︿•̀｡)</h2>
                <h5 class="text-center poppins"><strong>Payment Error</strong></h5>
                <p class="mb-0 text-center">${message}</p>
            </div>
        `;
    }

    const payPublishBtnBox = document.querySelector('#paymentPublishBtnBox');
    if (payPublishBtnBox) {
        payPublishBtnBox.innerHTML = `
            <button type="button" class="btn pay-publish-btn btn-dark w-100 shadow-none text-center" disabled>
                <span class="btn-text">Checkout Unavailable</span>
            </button>
        `;
    } else {
        // Popup mode: update popup elements to show error state
        const amountEl = document.getElementById('paymentPopupAmountValue');
        if (amountEl) amountEl.innerHTML = '<i class="bi bi-exclamation-circle text-danger"></i>';
        const periodEl = document.getElementById('paymentPopupAmountPeriod');
        if (periodEl) periodEl.textContent = message;
        const popupPayBtn = document.getElementById('paymentPopupPayBtn');
        if (popupPayBtn) {
            popupPayBtn.disabled = true;
            popupPayBtn.innerHTML = '<i class="bi bi-x-circle me-2"></i>Unavailable';
        }
    }
}

function initializePayment(amount, order_id, razorpay_key, currency, description, action, encrypted_invoice_data, invitation_data) {
    var template_id = document.querySelector('body').getAttribute('data-template-id');
    var options = {
        key: razorpay_key,
        amount: amount * 100, // Convert to paise
        currency: currency,
        name: "Eventic",
        description: description,
        order_id: order_id,
        handler: async function (response) {
            const csrftoken = (typeof getCookie === 'function' ? getCookie("csrftoken") : window.getCookie("csrftoken"));

            // Build multipart FormData: payment IDs + any pending media files
            const formData = new FormData();
            formData.append('csrfmiddlewaretoken', csrftoken);
            formData.append('payment_type', 'razorpay');
            formData.append('razorpay_payment_id', response.razorpay_payment_id);
            formData.append('razorpay_order_id', response.razorpay_order_id);
            formData.append('razorpay_signature', response.razorpay_signature);
            formData.append('amount', amount);
            formData.append('action', action);
            formData.append('templateID', template_id);
            formData.append('_hash_invitation_data', invitation_data);
            formData.append('_hash_invoice_data', encrypted_invoice_data);
            if (action === 'update') {
                formData.append('invitationUID', document.querySelector('body').getAttribute('data-invitation-uid'));
            }
            // Attach pending files (includes background_music if present) as files[key]
            Object.entries(window._pendingInvitationFiles || {}).forEach(([key, value]) => {
                if (Array.isArray(value)) {
                    value.forEach(f => formData.append(`files[${key}][]`, f));
                } else {
                    formData.append(`files[${key}]`, value);
                }
            });
            if (Object.keys(window._pendingFilesStatus || {}).length > 0) {
                formData.append('filesStatus', JSON.stringify(window._pendingFilesStatus));
            }

            try {
                const res = await fetch('/payment/payment-success/', {
                    method: 'POST',
                    credentials: 'same-origin',
                    body: formData,
                });
                const html = await res.text();
                document.open('text/html', 'replace');
                document.write(html);
                document.close();
            } catch (err) {
                console.error('Payment success request failed:', err);
                window.location.href = '/payment/payment-success/';
            }
        },
        modal: {
            ondismiss: function() {
                // Reset sidebar flow button
                const sidebarBtn = document.getElementById("razorpayBtn");
                if (sidebarBtn) {
                    const btnText = sidebarBtn.querySelector('.btn-text');
                    const btnLoader = sidebarBtn.querySelector('.btn-loader');
                    if (btnText && btnLoader) {
                        btnText.classList.remove('d-none');
                        btnLoader.classList.add('d-none');
                        sidebarBtn.disabled = false;
                    }
                }

                // Reset popup flow button
                const popupBtn = document.getElementById("paymentPopupPayBtn");
                if (popupBtn) {
                    const readyLabel = popupBtn.dataset.readyLabel || '<i class="bi bi-credit-card-fill me-2"></i>Pay & Publish';
                    popupBtn.innerHTML = readyLabel;
                    popupBtn.disabled = false;
                }

                if (window.gtag) {
                    gtag('event', 'payment_dismissed', {
                        'event_category': 'Payment Flow',
                        'event_label': 'Modal Closed'
                    });
                }
            }
        }
    };
    var rzp1 = new Razorpay(options);
    rzp1.open(); // Open Razorpay modal immediately
}

// Export functions for webpack/module bundling
window.initializePayment = initializePayment;
window.showPaymentError = showPaymentError;

// Animate payment/checkout content
function animatePaymentContent() {
    const paymentContainer = document.getElementById("paymentContainer");
    
    if (!paymentContainer) return;

    // Get all animatable elements in the payment container
    const validityBox = paymentContainer.querySelector('.row.justify-content-center');
    const images = paymentContainer.querySelectorAll('img');
    const tableRows = paymentContainer.querySelectorAll('table tbody tr');
    const savedAmountBox = paymentContainer.querySelector('.row.p-3.align-items-center.bg-light');
    const textMuted = paymentContainer.querySelector('.text-muted');
    const footerButtons = paymentContainer.querySelector('.form-footer');

    // Create timeline for smooth sequential animation
    const tl = gsap.timeline({
        defaults: {
            ease: "power2.out",
            duration: 0.5
        },
        onComplete: () => {
            // Clear inline styles after animation but preserve overflow and border-radius
            [validityBox, ...images, ...tableRows, savedAmountBox, textMuted, footerButtons].forEach(el => {
                if (el) gsap.set(el, { clearProps: "opacity,y,transform,x,scale" });
            });
        }
    });

    // Animate validity box (if present)
    if (validityBox) {
        tl.fromTo(validityBox, 
            { opacity: 0, y: 30 },
            { 
                opacity: 1, 
                y: 0,
                duration: 0.6,
                ease: "power3.out"
            }, 
            0.1
        );
    }

    // Animate table rows one by one
    if (tableRows.length > 0) {
        tl.fromTo(tableRows, 
            { opacity: 0, x: -20 },
            { 
                opacity: 1, 
                x: 0,
                stagger: 0.08,
                duration: 0.5,
                ease: "power3.out"
            }, 
            0.3
        );
    }

    // Animate saved amount box with pop effect
    if (savedAmountBox) {
        tl.fromTo(savedAmountBox, 
            { opacity: 0, scale: 0.95, y: 20 },
            { 
                opacity: 1, 
                scale: 1, 
                y: 0,
                duration: 0.6,
                ease: "back.out(1.3)"
            }, 
            "-=0.2"
        );
    }

    // Animate text info
    if (textMuted) {
        tl.fromTo(textMuted, 
            { opacity: 0, y: 15 },
            { 
                opacity: 1, 
                y: 0,
                duration: 0.4
            }, 
            "-=0.2"
        );
    }

    // Animate footer with price and button
    if (footerButtons) {
        tl.fromTo(footerButtons, 
            { opacity: 0, y: 20 },
            { 
                opacity: 1, 
                y: 0,
                duration: 0.6,
                ease: "back.out(1.5)"
            }, 
            "-=0.1"
        );
    }
}

window.animatePaymentContent = animatePaymentContent;

// For ES6 module compatibility
if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
        setupPaymentHandlers: window.setupPaymentHandlers,
        processToPayment: window.processToPayment,
        initializePayment: window.initializePayment,
        showPaymentError: window.showPaymentError,
        animatePaymentContent: window.animatePaymentContent
    };
}

// For AMD module compatibility
if (typeof define === 'function' && define.amd) {
    define([], function() {
        return {
            setupPaymentHandlers: window.setupPaymentHandlers,
            processToPayment: window.processToPayment,
            initializePayment: window.initializePayment,
            showPaymentError: window.showPaymentError,
            animatePaymentContent: window.animatePaymentContent
        };
    });
}
